import { handleActions } from 'redux-actions';
import { converge, mergeRight } from 'ramda';

import { LANDING_PAGE } from 'app/features/deltaConfig/constants';
import { FETCH_DELTA_CONFIG_SUCCESS } from 'app/features/deltaConfig/actionTypes';
import { pathFromPayload, pickState } from 'app/reducers/helpers';

const initialState = {
  titleKey: 'landing_plan_comparison_title',
  subtitleKey: 'landing_plan_comparison_subtitle',
  mangaAndStoreAvailabilityKey: 'landing_manga_and_store_availability',
  videoAvailabilityKey: 'landing_video_content_availability',
};

const productComparison = handleActions(
  {
    [FETCH_DELTA_CONFIG_SUCCESS]: converge(mergeRight, [
      pickState,
      pathFromPayload([LANDING_PAGE, 'productComparison']),
    ]),
  },
  initialState,
);

export { initialState };

export default productComparison;
